import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import VueLazyload from 'vue-lazyload'
import "lib-flexible";
// import Qs from 'qs'
import MD5 from "js-md5";
import Meta from "vue-meta";
import Axios from "@/utils/axios";
import { downloadFile } from "@/utils/util";
import { Base64 } from "js-base64";
Vue.use(Base64);
Vue.use(Meta);
Vue.config.productionTip = false;
Vue.prototype.$axios = Axios; //引用axios
Vue.prototype.$MD5 = MD5;
Vue.prototype.$DownloadFile = downloadFile;

import scroll from "vue-seamless-scroll";
Vue.use(scroll);
import "element-ui/lib/theme-chalk/index.css";
import element from "./element/index";
Vue.use(element);

//引入quill-editor编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

//实现quill-editor编辑器拖拽上传图片
import * as Quill from "quill";
import { ImageDrop } from "quill-image-drop-module";
Quill.register("modules/imageDrop", ImageDrop);

//实现quill-editor编辑器调整图片尺寸
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageResize", ImageResize);

// Vue.use(VueLazyload)
new Vue({
  router,
  // Qs,
  store,
  render: (h) => h(App),
}).$mount("#app");
